import React, { PureComponent, Fragment } from 'react';
import classnames from 'classnames';
import Utils from '~/core/scripts/utils';
import Card from '~/core/scripts/components/Card';
import Icon from '~/core/scripts/components/Icon'
import { getCurrentScale } from '~/kits/general/utils';
import { trackEvent } from '~/core/scripts/utils';

const config = ARTICLE_CONFIG;

const cardPresets = [
  'Essen',
  'Braunschweig',
  'Erfurt',
  'Potsdam',
  'Kiel',
  'München',
  'Chemnitz',
  'Düsseldorf',
  'Stuttgart',
  'Köln',
  'Trier'
];

function getSharingSentence(data, city) {
  return `Handy-Daten verraten, wo die Nutzer aus ${city} die Sommerferien verbringen`;
  // return `Die meisten Menschen aus ${city} fahren in den Sommerferien nach ${data[0].name} (${Utils.numberFormat(data[0].value, 1)} %)`;
}

function getTwitterSentence(data, city) {
  return `${getSharingSentence(data, city)} ${config.meta.ogUrl}`;
}

class CityTableApp extends PureComponent {
  constructor() {
    super();

    this.currentData = null;
    this.currentCity = null;
  }

  onFbShare = (data) => {
    Utils.trackEvent('share', 1, 'class_C');
    FB.ui({
      method: 'share',
      href: config.meta.ogUrl,
      quote: getSharingSentence(this.currentData, this.currentCity)
    }, resp => {
      console.log(resp);
    });
  }

  renderCard = (data) => {
    if (data === null) {
      return null;
    }

    const cityNames = Object.keys(data).filter(d => d !== 'Stadt');
    const arrayData = cityNames.map(name => ({ name, value: +data[name] }));
    const sortedData = arrayData.sort(Utils.sortByKey('value')).slice(0, 10);
    const isBigCity = ['Berlin', 'Hamburg'].includes(data.Stadt);

    this.currentData = sortedData;
    this.currentCity = data.Stadt;

    trackEvent('city_result', data.Stadt, 'class_C');

    return (
      <Fragment>
        <div className="listview">
          <div className="hd__title-text">
            <div className="hd__title-main">Top-Auslandziele in den Sommerferien</div>
            <div className="hd__title-sub">für <strong>{data.Stadt}{isBigCity ? '*' : ''}</strong></div>
          </div>
          <ul className="list">
            {sortedData.map((d, i) => (
              <li
                key={d.name}
                className={classnames('list__item', `step-${getCurrentScale(d.value)}`)}
              >
                <div className="list__index">{i + 1}</div>
                <div className="list__name">{d.name}</div>
                <div className="list__value">{Utils.numberFormat(d.value, 1)} %</div>
              </li>
            ))}
          </ul>
          <div className="list__coldesc">Anteile von deutschen Handy-Nutzern im EU-Ausland plus Island, Liechtenstein und Norwegen</div>
          {isBigCity && <div className="list__annotation">*Hinweis: Nur mobile Datennutzung berücksichtigt</div>}
          <div className="list__sharer">
            <div className="list__sharer-cta">Liste teilen:</div>
            <div className=" list__sharer-button fb">
              <button className="btn fb" onClick={this.onFbShare}>
                <Icon type="fb" /> Facebook
              </button>
            </div>
            <a target="_blank" className="list__sharer-button tw" href={`https://twitter.com/intent/tweet?source=${encodeURIComponent(config.meta.ogUrl)}&text=${encodeURIComponent(getTwitterSentence(this.currentData, this.currentCity))}`}>
              <button className="btn tw"><Icon type="tw" /> Twitter</button>
            </a>
          </div>
        </div>
      </Fragment>
    );
  }

  render() {
    return (
      <div className="citytable">
        <Card
          placeholder="Stadt suchen ..."
          dataSource="data/reiseziele_cities.csv"
          fieldName="Stadt"
          renderCard={this.renderCard}
          presets={cardPresets}
        />
      </div>
    );
  }
}

export default CityTableApp;
